import { render, staticRenderFns } from "./AccountSecurity.vue?vue&type=template&id=1078e4d4&scoped=true"
import script from "./AccountSecurity.vue?vue&type=script&lang=js"
export * from "./AccountSecurity.vue?vue&type=script&lang=js"
import style0 from "./AccountSecurity.vue?vue&type=style&index=0&id=1078e4d4&prod&scoped=true&lang=css"
import style1 from "./AccountSecurity.vue?vue&type=style&index=1&id=1078e4d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078e4d4",
  null
  
)

export default component.exports